import { getMerchantToken } from "./merchantAuthApi";

const API_BASE_URL = (
  process.env.REACT_APP_MERCHANT_API_BASE_URL ||
  "http://secondbite-manage.localhost/merchant-api/v1"
).replace(/\/+$/, "");

const request = async (path, options = {}) => {
  let response;
  try {
    response = await fetch(`${API_BASE_URL}${path}`, {
      ...options,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${getMerchantToken()}`,
        ...options.headers,
      },
    });
  } catch {
    throw new Error("Unable to connect to the SecondBite backend.");
  }

  const payload = await response.json().catch(() => null);
  if (!response.ok || !payload?.success) {
    const validationMessage = payload?.errors
      ? Object.values(payload.errors).flat()[0]
      : null;
    throw new Error(validationMessage || payload?.message || "Unable to process the staff request.");
  }
  return payload.data;
};

export const getMerchantStaff = () => request("/staff");
export const getMerchantStaffMember = (type, id) => request(`/staff/${type}/${id}`);
export const createMerchantOperator = (data) => request("/staff", {
  method: "POST",
  body: JSON.stringify(data),
});
export const updateMerchantOperator = (id, data) => request(`/staff/${id}`, {
  method: "PUT",
  body: JSON.stringify(data),
});
export const updateMerchantOperatorStatus = (id, status) => request(`/staff/${id}/status`, {
  method: "PATCH",
  body: JSON.stringify({ status }),
});
